<template>
  <span class="text-2xl font-semibold">VT Study管理画面</span>
</template>
